import { graphql } from "gatsby";
import React, { FC } from "react";

import { Container } from "../../container";

export interface EmbeddedContentProps extends Queries.EmbeddedContentDataFragment {}

export const EmbeddedContent: FC<EmbeddedContentProps> = ({ title, iframeUrl, iframeHeight }) => {
  return (
    <Container containerClassName="container p-2 md:p-3 lg:p-5 mt-8" pagePaddingX>
      {title && <h2 className="text-3xl lg:text-4xl mb-6 lg:mb-8 text-primary">{title}</h2>}
      {iframeUrl && (
        <iframe
          title={title ?? ""}
          src={iframeUrl ?? ""}
          className="w-full"
          height={iframeHeight ?? 500}
        />
      )}
    </Container>
  );
};

export const query = graphql`
  fragment EmbeddedContentData on ContentfulEmbeddedContent {
    title
    iframeUrl
    iframeHeight
  }
`;
